<script lang="ts">
  import type { EditorState } from '../editor-state.svelte';
  import type { PanelSections } from '../panel-sections.svelte';
  import PanelRail from './PanelRail.svelte';
  import ResizeHandle from './ResizeHandle.svelte';
  import SectionHeading from './SectionHeading.svelte';
  import { LEFT_PANEL_SECTIONS } from './left-panel-sections';
  import './panel-list.css';

  const { editor, panel }: { editor: EditorState; panel: PanelSections } = $props();

  // Showing or hiding the column resizes the canvas, which mid-gesture would shift the
  // drawing under the pointer.
  const resizeLocked = $derived(editor.inProgress);
</script>

<aside class="left" aria-label="Drawing">
  <PanelRail
    {panel}
    sections={LEFT_PANEL_SECTIONS}
    side="left"
    name="panel"
    controls="left-panel-sections"
    locked={resizeLocked}
  />

  {#if !panel.collapsed}
    <div id="left-panel-sections" class="sections" style:width="{panel.width}px">
      <div class="scroll">
        {#each LEFT_PANEL_SECTIONS as section (section.id)}
          {#if panel.shown === section.id}
            <section class="section" aria-labelledby="section-label">
              <SectionHeading {editor} {section} id="section-label" />
              <section.body {editor} />
            </section>
          {/if}
        {/each}
      </div>
    </div>
    <ResizeHandle
      {panel}
      edge="right"
      label="Resize panel"
      controls="left-panel-sections"
      locked={resizeLocked}
    />
  {/if}
</aside>

<style>
  .left {
    position: relative;
    display: flex;
    min-height: 0;
    border-right: 1px solid var(--color-border);
    background: var(--color-surface);
  }

  .sections {
    display: flex;
    flex: none;
    flex-direction: column;
    min-height: 0;
  }

  .scroll {
    display: flex;
    flex: 1;
    flex-direction: column;
    min-height: 0;
    overflow-y: auto;
  }

  /* A column, so a body's list can take the height left under its controls and scroll. */
  .section {
    display: flex;
    flex: 1;
    flex-direction: column;
    min-height: 0;
    padding: var(--space-2) var(--space-3) var(--space-3);
  }
</style>
